import { Container, Text } from './styles'
import React from 'react'
import InputMask from 'react-input-mask'

interface IinputTextProps {
  label: string
  type: string
  placeholder: string
  name: string
  value: string
  handleChange: (input: React.ChangeEvent<HTMLInputElement>) => void
  mask?: string
  error: boolean
}

const InputText = ({
  label,
  type,
  placeholder,
  name,
  value = '',
  mask = '',
  error,
  handleChange,
}: IinputTextProps) => {
  return (
    <Container>
      <Text>{label}</Text>
      <InputMask
        mask={mask}
        type={type}
        placeholder={placeholder}
        onChange={handleChange}
        name={name}
        value={value}
        className={error ? 'inputError input' : 'input'}
      />
      {error && (
        <span className="error">Digite o campo {name} corretamente!</span>
      )}
    </Container>
  )
}

export default InputText
